import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'sledRunner',
      d: 'M-3.5,-2h0.5v1h-0.5zM-4,-1h1.5v1.5h-1.5zM-2,-0.5h0.5v0.5h-0.5zM-2,0h2v0.5h-2zM0.5,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5zM-3.5,0.5h3.5v0.5h-3.5zM0.5,0.5h1.5v0.5h-1.5zM3,0.5h1v0.5h-1zM-1.5,1h3.5v0.5h-3.5zM2.5,1h1v0.5h-1zM1.5,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'sledWood',
      d: 'M-3,-1.5h2v0.5h-2zM-2.5,-1h3v0.5h-3zM3,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v1h-0.5zM-0.5,-0.5h4v0.5h-4zM0,0h0.5v1h-0.5zM1,0h2v0.5h-2zM2,0.5h1v0.5h-1zM2,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-2.5,-2.5h1v0.5h-1zM-3,-2h3.5v0.5h-3.5zM-1,-1.5h3v0.5h-3zM0.5,-1h2.5v0.5h-2.5z',
    },
  ],
  pixels: 92,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'sledRunner',
      d: 'M-3.5,-2h0.5v1h-0.5zM-4,-1h1.5v1.5h-1.5zM-2,-0.5h0.5v0.5h-0.5zM-2,0h2v0.5h-2zM0.5,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5zM-3.5,0.5h3.5v0.5h-3.5zM0.5,0.5h1.5v0.5h-1.5zM3,0.5h1v0.5h-1zM-1.5,1h3.5v0.5h-3.5zM2.5,1h1v0.5h-1zM1.5,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'sledWood',
      d: 'M-3,-1.5h1v0.5h-1zM-2.5,-1h2v0.5h-2zM3,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v1h-0.5zM-0.5,-0.5h4v0.5h-4zM0,0h0.5v1h-0.5zM1,0h2v0.5h-2zM2,0.5h1v0.5h-1zM2,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-2.5,-2.5h0.5v0.5h-0.5zM0.5,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM0.5,-1.5h1v0.5h-1zM0.5,-1h2.5v0.5h-2.5z',
    },
    { paint: 'christmasRed', d: 'M-1.5,-2.5h0.5v1h-0.5zM-2,-1.5h1v0.5h-1z' },
    { paint: 'scarfRed', d: 'M-2,-2.5h0.5v1h-0.5zM0,-2.5h0.5v0.5h-0.5zM-0.5,-2h1v1.5h-1z' },
    {
      paint: 'christmasGold',
      d: 'M-1,-3.5h1v0.5h-1zM-1.5,-3h2.5v0.5h-2.5zM-1,-2.5h1v0.5h-1zM-1,-2h0.5v1h-0.5z',
    },
    { paint: 'christmasGreen', d: 'M2,-2.5h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM1.5,-2h1v1h-1z' },
    { paint: 'snowCap', d: 'M1,-2.5h1v0.5h-1zM1,-2h0.5v0.5h-0.5z' },
  ],
  pixels: 112,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M-4,0h0.5v0.5h-0.5zM-3,0h0.5v0.5h-0.5zM-3.5,0.5h0.5v0.5h-0.5zM-1.5,0.5h1v0.5h-1zM-2,1h0.5v0.5h-0.5zM3,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'sledRunner',
      d: 'M-3.5,-2h0.5v1h-0.5zM-4,-1h1.5v1h-1.5zM-2,-0.5h0.5v0.5h-0.5zM-3.5,0h0.5v0.5h-0.5zM-2.5,0h2.5v0.5h-2.5zM0.5,0h0.5v0.5h-0.5zM3.5,0h0.5v0.5h-0.5zM-3,0.5h1.5v0.5h-1.5zM-0.5,0.5h0.5v0.5h-0.5zM0.5,0.5h1.5v0.5h-1.5zM3,0.5h1v0.5h-1zM-1.5,1h3.5v0.5h-3.5zM2.5,1h1v0.5h-1zM1,1.5h2v0.5h-2z',
    },
    {
      paint: 'sledWood',
      d: 'M-3,-1.5h1.5v0.5h-1.5zM-2.5,-1h3v0.5h-3zM3,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h4v0.5h-4zM0,0h0.5v1h-0.5zM1,0h2v0.5h-2zM2,0.5h1v0.5h-1zM2,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-2.5,-2.5h1v0.5h-1zM-2.5,-2h3v0.5h-3zM-1,-1.5h3v0.5h-3zM0.5,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'bareBranch',
      d: 'M-4,-3h0.5v0.5h-0.5zM-4.5,-2.5h1.5v0.5h-1.5zM-5,-2h1v0.5h-1zM-3,-2h0.5v0.5h-0.5zM-4.5,-1.5h0.5v1h-0.5zM-1.5,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 103,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
